import type { CountryOption } from '../model'
import type { CountriesList } from './types'

import { pinnedCountries, pinnedOrder } from '../config'

export function mapCountries(countries: CountriesList['country_list']): CountryOption[] {
    return countries
        .filter((country) => country.country_alpha3 && country.country_alpha3 !== 'ALL')
        .map((country) => ({
            id: country.country_alpha3,
            label: country.country_name,
            pinned: pinnedCountries.includes(country.country_alpha3),
        }))
        .sort((a, b) => {
            const aIndex = pinnedOrder.get(a.id)
            const bIndex = pinnedOrder.get(b.id)

            // если обе страны pinned → сортируем по порядку в массиве
            if (aIndex !== undefined && bIndex !== undefined) {
                return aIndex - bIndex
            }

            // pinned всегда выше обычных
            if (aIndex !== undefined) return -1
            if (bIndex !== undefined) return 1

            // обе не pinned → порядок не меняем
            return 0
        })
}
